import styled from 'styled-components'
import variables, { device, colors } from 'Styled/variables'

interface Props {
  searchError?: boolean
  comment?: boolean
  isConnecting?: boolean
}

export const MainWrapper = styled.div`
  background-color: ${colors.white};
  min-height: 100vh;

  @media ${device.mobileMin} {
    background-color: black;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const Header = styled.div`
  background-color: black;
  padding: 12px 16px;
  @media ${device.mobileMin} {
    padding: 0;
  }
`

export const Logo = styled.div`
  width: 149px;

  @media ${device.mobileMin} {
    width: 156px;
    margin-bottom: 16px;
  }
`

export const LoginFieldsWrapper = styled.div`
  background-color: ${colors.white};
  padding: 49px 16px 16px 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${device.mobileMin} {
    width: 400px;
    border-radius: 8px;
    padding: 16.5px 24px 24px 24px;
  }
`

export const LoginTitle = styled.div`
  font-size: ${variables.fontSize18};
  color: ${colors.mainText};
  line-height: 27px;
  margin-bottom: 24px;
  text-align: center;
`

export const TitleAccent = styled.span`
  color: ${colors.green};
`

export const Text1 = styled.div`
  font-size: ${variables.fontSize14};
  color: ${colors.mainText};
  line-height: 21px;
  display: grid;
  gap: 16px;
  margin-bottom: 24px;
`

export const Text2 = styled.div`
  font-size: ${variables.fontSize14};
  color: ${colors.mainText};
  line-height: 21px;
  display: grid;
  gap: 16px;
  margin-bottom: 24px;
  @media (min-width: 576px) {
    margin-bottom: 16px;
  }
`
export const Text3 = styled.div`
  font-size: ${variables.fontSize14};
  color: ${colors.mainText};
  line-height: 21px;
  display: grid;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 576px) {
    margin-bottom: 16px;
  }
`

export const SuccessText = styled.div`
  font-size: ${variables.fontSize18};
  line-height: 27px;
  display: grid;
  margin-bottom: 32px;

  @media (min-width: 576px) {
    margin-bottom: 24px;
  }
`

export const SuccessCircle = styled.div`
  padding-top: 8px;
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-bottom: 24px;
`

export const StyledInput = styled.input<Props>`
  height: 47px !important;
  font-size: ${variables.fontSize14};
  border: ${(props: Props) =>
    props.comment || props.searchError
      ? `1px solid ${colors.messegesRed}`
      : `1px solid ${colors.greyStroke}`};
  border-radius: 8px;
  outline: none;
  padding: 16px;
  width: 100%;
  margin-bottom: ${(props: Props) =>
    props.comment || props.searchError ? '8px' : '24px'};
  background-color: ${colors.white};
  line-height: 21px;
  color: ${colors.mainText};

  &::-webkit-input-placeholder {
    color: ${colors.greyTextWhiteBg};
  }

  &:focus {
    background-color: ${colors.white};
    outline: none;
    color: ${colors.mainText};
  }
  &:active {
    background-color: ${colors.white};
    outline: none;
    color: ${colors.mainText};
  }
`

export const Search = styled.div`
  width: 100%;
  margin-bottom: 24px;
`

export const SearchResult = styled.div`
  padding: 8px 16px;
  background: ${colors.white};
  border-radius: 8px;
  border: 1px solid ${colors.greyStroke};
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  align-items: center;
`

export const SearchFoto = styled.div`
  border-radius: 60px;
  width: 40px;
  height: 40px;
  overflow: hidden;
`

export const SearchText = styled.div`
  font-size: ${variables.fontSize14};
  line-height: 21px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: ${colors.mainText};
`

export const SearchTextTitle = styled.div`
  font-weight: 600;
`

export const FormText = styled.div`
  color: ${colors.mainText};
  margin-bottom: 8px;
`
export const Form = styled.form`
  width: 100%;
`

export const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: ${(props: Props) => (props.comment ? '8px' : '0px')};
`

export const Comment = styled.div`
  font-weight: normal;
  font-size: ${variables.fontSize14};
  line-height: 21px;
  color: ${colors.green};
  margin-bottom: 24px;
`

export const Red = styled.div`
  font-weight: normal;
  font-size: ${variables.fontSize14};
  line-height: 21px;
  color: ${colors.messegesRed};
  margin-bottom: 16px;
  display: flex;
  align-self: flex-start;
  height: 42px;
`
export const WrapperForIcon = styled.div`
  width: 12.9px;
  height: 14.55px;
  margin-right: 9.54px;
  display: flex;
`

export const ConfirmationText = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 16px;
  text-align: center;
`
export const Center = styled.div`
  font-size: ${variables.fontSize14};
  line-height: 21px;
  text-align: center;
  margin-bottom: 52px;
  @media (min-width: 576px) {
    margin-bottom: 29px;
  }
`

export const BtnsWrapper = styled.div`
  font-size: ${variables.fontSize14};
  line-height: 21px;
  color: ${colors.mainText};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  align-items: center;
  margin-bottom: 8px;
`
export const ErrorText = styled.div`
  text-align: left;
  color: ${colors.messegesRed};
  font-size: ${variables.fontSize14};
  font-weight: 400;
  margin-top: 0px;
  margin-bottom: 8px;
  margin-bottom: 24px;
`

export const TikTokBtnLink = styled.a<Props>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  font-family: 'Segoe UI', 'Roboto', sans-serif !important;
  outline: none;
  box-sizing: border-box;
  border: ${(props: Props) =>
    props.isConnecting
      ? `1px solid ${colors.greyStroke}`
      : `1px solid ${colors.greyTextBlackBg}`};
  border-radius: 27px;
  height: 40px;
  padding: 9.5px 24px 9.5px 24px;
  color: ${(props: Props) =>
    props.isConnecting ? colors.greyTextBlackBg : colors.mainText};
  cursor: pointer;
  font-size: 14px;
  background: ${colors.white};
  width: auto;
  justify-content: flex-start;

  &:hover {
    background: ${colors.white};
    color: ${(props: Props) =>
      props.isConnecting ? colors.greyTextBlackBg : colors.mainText};
  }
  &:active {
    color: ${(props: Props) =>
      props.isConnecting ? colors.greyTextBlackBg : colors.mainText};
  }
  &:visited {
    background: ${colors.white};
    color: ${(props: Props) =>
      props.isConnecting ? colors.greyTextBlackBg : colors.mainText};
  }
`
export const ErrorContainer = styled.div`
  display: flex;
  font-display: row;
  color: ${colors.messegesRed};
  align-items: flex-start;
  margin-bottom: 16px;
  text-align: left;
`
export const TextError = styled.div`
  text-align: left;
  line-height: 21px;
`
